import { MathUtils, Mesh } from 'three';

import FullScreenTriangle from '../../globals/FullScreenTriangle';

import { BackgroundMaterial } from './Material';

export class Background extends Mesh {
    private _brightness: number;

    constructor() {
        const geometry = new FullScreenTriangle();
        const material = new BackgroundMaterial();

        super(geometry, material);

        this.renderOrder = -10000;
        this._brightness = 1;
        this.frustumCulled = false;
        this.matrixAutoUpdate = false;
    }

    set brightness(value: number) {
        this._brightness = value;
    }

    get brightness() {
        return this._brightness;
    }

    set error(value: boolean) {
        const material = this.material as BackgroundMaterial;
        material.error = value;
    }

    get error() {
        const material = this.material as BackgroundMaterial;
        return material.error;
    }

    setSize(width, height) {
        const material = this.material as BackgroundMaterial;
        material.resize(width, height);
    }

    update(delta) {
        if (!this.visible) return;

        const material = this.material as BackgroundMaterial;
        material.uniforms.brightness.value = MathUtils.damp(
            material.uniforms.brightness.value,
            this.brightness,
            2,
            delta * 1,
        );
    }
}
